import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const Complex = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesCustomerExperience = [
    {
      id: 1,
      title: 'complex_page.relatedCases.items.roadmaps.title',
      description: 'complex_page.relatedCases.items.roadmaps.description',
      icon: '',
      url: 'road-maps',
    },
    {
      id: 2,
      title: 'complex_page.relatedCases.items.redesenhoDoFluxo.title',
      description: 'complex_page.relatedCases.items.redesenhoDoFluxo.description',
      icon: '',
      url: 'redesenho-do-fluxo',
    },
    {
      id: 3,
      title: 'complex_page.relatedCases.items.serviceDesignSac.title',
      description: 'complex_page.relatedCases.items.serviceDesignSac.description',
      icon: '',
      url: 'service-design-SAC',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('complex_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'cx_case_related_case_click',
      cta_location: 'cx_case',
      page_name: 'complex',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('complex_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('complex_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">{t('complex_page.sections.challenge.title')}</h3>
          <p>{t('complex_page.sections.challenge.description')}</p>

          <h3>{t('complex_page.sections.approach.title')}</h3>
          <p>
            {t('complex_page.sections.approach.p1')} <br />{' '}
            {t('complex_page.sections.approach.p2')}
          </p>
          <ul>
            <li>{t('complex_page.sections.approach.items.item1')}</li>
            <li>{t('complex_page.sections.approach.items.item2')}</li>
            <li>{t('complex_page.sections.approach.items.item3')}</li>
          </ul>

          <hr />

          <h3>{t('complex_page.sections.result.title')}</h3>
          <p>{t('complex_page.sections.result.description')}</p>

          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('complex_page.relatedCases.title')}</h2>
        <span className="subtitle">{t('complex_page.relatedCases.subtitle')}</span>

        <Pagination data={casesCustomerExperience} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('complex_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default Complex
